import React, { useEffect, useState, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRealtimeDrivers } from 'Core/hooks';

import IconPicker from 'Modules/.common/components/IconPicker';
import { Grid, Typography } from '@mui/material';

import { TypeLayer, EnumIconSize } from '../../../../../../components/Map/providers/enums'
import { IconReactMarkerRouteFSMPoint } from '../../../../../../components/Map/iconsReact'
import {
  Input, Switch, IconButton, MenuComponent, Loading,
  Select, DatePicker, Pill, Tooltip, Form, Icons, Button
} from '@gpstrackit/gtc-react-controls';
import { useIntl } from 'react-intl';
import { NotificationManager } from 'Components/Notifications';
import { HasPermission } from "Core/security";
import { GetFormatForMoment } from 'Core/data/Helpers';
import AccordionComponent from "../../../../../../components/Accordion"
import { formatDatetime } from 'Modules/reports/views/main/components/reportsTab/helper';

import DragDropList from 'Components/DragDropList';
import Preferences from 'Core/containers/Preferences';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

import CreateEditRoutePoint from '../createEditRoutePoint'

import moment from 'moment';

import './style.scss';

import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';




// Actions
import {
  savePreference,
  setMapRoutesOptions,
  drawGetDirections,
  addPointers,
  openModalMarkerRoute,
  //methods to print route

  setToggleFullScreen,
  routesCreateUpdateRoute,
  openModalCreateEditRouteModalMain,
  routesSearchRoutes,
  openModalRoutesCloneRoute,
  catalogLoad,
  printView,
  onUpdateRoute
} from 'Redux/actions';


import { openModalDeleteRoutePoints } from '../deleteRoutePoint/redux/slice'
import { openModalRouteDirections } from '../modalDirections/redux/slice';
import { openModalCreateEditRoutePoint } from '../createEditRoutePoint/redux/slice';

//Max days to close route is 7
const maxDaysToCloseRoute = 168;

const defaultColor = '8677D9';

const EditPanelForm = forwardRef((props, ref) => {

  const {
    editMode: paramEditMode,
    mapRef,
    newPointers,
    saveRoute,
    onDisableSave,
    isRealtimeMaps,
    formData,
    setFormData,
    setDataPointsFromMap,
    dataPointsFromMap,
    setPointUnsaved
  } = props;

  const { messages, locale } = useIntl();

  const [generatePrint, setGeneratePrint] = useState(false)
  const [preferences, setPreferences] = useState()
  const preferencesKey = 'routesOptions';

  const [accordionValue, setAccordionValue] = useState([
    { id: 0, name: messages['fsmRoute_edit_panel_route_accordion_point'], status: false },
    { id: 1, name: messages['fsmRoute_edit_panel_route_accordion_stops'], status: false }
  ]);

  useImperativeHandle(ref, () => ({
    refreshDirections,
    centerRouteOnMap
  }));

  const dispatch = useDispatch();
  const designForm = Form.useForm();

  //new useSelector
  const route = useSelector(state => state.routesManagerEditPanelRouteRedux?.route);

  const realtimeMapsRouteEditRouteId = useSelector(state => state?.realtimeMapsRoutesModalCreateEditRoute?.routeId);

  const editMode = realtimeMapsRouteEditRouteId > 0 || route?.id > 0 ? true : paramEditMode

  const loadingRouteMain = useSelector(state => state?.routesManagedCreateEditRouteModalMainRedux?.loading);
  const loadingRouteEditRoute = useSelector(state => state?.routesManagerEditPanelRouteRedux?.loadingRoute);
  const loadingRoute = loadingRouteMain || loadingRouteEditRoute

  const isEditPoint = useSelector(state => state.routesManagedCreateEditRoutePointRedux.point);
  const errorOnMap = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.errorOnMap);
  const timeZone = useSelector(state => state.securityRedux.user.timeZone);

  const isNewRoutesTrackerRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isNewRoutesTracker);
  const isNewRoutesTrackerRealtime = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute?.isNewRoutesTracker);
  const isNewRoutesTracker = isNewRoutesTrackerRoute || isNewRoutesTrackerRealtime;

  const isRoutesTrackerRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isRoutesTracker);
  const isRoutesTrackerRealtime = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute?.isRoutesTracker);
  const isRoutesTracker = isRoutesTrackerRoute || isRoutesTrackerRealtime;

  //to create a new template
  const paramIsTemplateRoutesModalMain = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isTemplate);
  const paramIsTemplateRealtimeMapsRoutes = useSelector(state => state.realtimeMapsRoutesModalCreateEditRoute?.isTemplate);
  const paramIsTemplate = paramIsTemplateRoutesModalMain || paramIsTemplateRealtimeMapsRoutes || false;

  const paramDriverId = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.driverId);
  const paramTemplateRouteId = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.templateRouteId);
  const paramScheduledAt = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.scheduledAt);
  const isCloneRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.isCloneRoute);
  const loadingCloneRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.loadingCloneRoute);

  //loading for delete routes
  const loadingDeleteModal = useSelector(state => state.routesManagerDeleteRedux?.loading);
  const dateformat = useSelector(state => state.securityRedux.user.dateformat);

  const { authenticatedId } = useSelector(state => state.securityRedux);
  const jsonLandmark = useSelector((state) => state.catalogsRealtimeRedux.landmarks);
  const loadingLandmarkJson = useSelector((state) => state.catalogsRealtimeRedux.loadingLandmarks);

  //const routeEditData = useSelector(state => state.routesManagedReduxOld?.openModalCreateEditRoute?.data);
  const isOpenModalRouteDirections = useSelector(state => state.routesManagedDirectionRedux?.open);
  const user = useSelector((state) => state.securityRedux.user);
  const timeZoneUser = useSelector((state) => state.securityRedux.user.timeZone);
  const drivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });
  const loadingDrivers = useSelector(state => state.catalogsRedux.loadingDrivers);
  const contacts = useSelector(state => state.catalogsRedux.contacts);
  const loadingContacts = useSelector(state => state.catalogsRedux.loadingContacts);

  let colorToRoute = formData?.color?.replace('#', '')
  colorToRoute = colorToRoute ? `#${colorToRoute}` : `#${defaultColor}`;

  function findLandmarkName(landmarkId) {
    if (!jsonLandmark) return ''

    const landmark = jsonLandmark?.find((item) => item.id == landmarkId)
    if (landmark) return landmark?.name || ''
    return '';
  }

  useEffect(() => {
    mapRef.current.setZoom()
    dispatch(catalogLoad(['contacts']));

    return () => {
      //setFormData({});
      designForm?.resetValues();
    }
  }, [])

  useEffect(() => {
    let scheduledAt, driverId, dateOnTimeZone, fechaUTC
    if (!loadingRoute && route?.id > 0 && !loadingCloneRoute && !formData?.startingLoad) {
      //create a temporal name for route
      let newNameCloneRoute = route?.title || ''

      let isTemplate = route?.isTemplate;
      driverId = route?.driverId;
      scheduledAt = route?.scheduledAt;
      let templateRouteId = route?.templateRouteId;

      let currentDate = new Date();
      let currentDateEpoch = currentDate.getTime();
      currentDateEpoch = Math.floor(currentDateEpoch / 1000)
      if (paramTemplateRouteId > 0) {
        newNameCloneRoute = `${route?.title?.includes('copy of_') ? route?.title : 'copy of_'}${route?.title}_${currentDateEpoch}`;

        isTemplate = paramIsTemplate;
        driverId = route?.driverId || paramDriverId;
        templateRouteId = route?.templateRouteId || paramTemplateRouteId;

      } else if (isCloneRoute) {
        newNameCloneRoute = `${route?.title?.includes('copy of_') ? route?.title : 'copy of_'}${route?.title}_${currentDateEpoch}`;
        dispatch(onUpdateRoute({ route, changesToSavePoints: true }))
      }

      dateOnTimeZone = moment(), fechaUTC = moment()
      scheduledAt = route?.scheduledAt || paramScheduledAt;
      if (scheduledAt) {
        fechaUTC = formatDatetime(scheduledAt, `YYYY/MM/DD h:mm A`, timeZoneUser)
      }

      setFormData(formData => ({
        ...formData,
        ...route,
        scheduledAt: fechaUTC,
        title: newNameCloneRoute,
        isTemplate: isTemplate,
        driverId: driverId,
        templateRouteId: templateRouteId,
        optimized: false,
        id: isNewRoutesTracker ? 0 : route?.id,
        startingLoad: true,
        checkCloseMinsAfterActivated: route?.closeMinsAfterActivated > 0 || (isNewRoutesTracker && preferences?.prefCloseWithLastStop) ? true : false,
        closeWithLastStop: route?.closeWithLastStop || (isNewRoutesTracker && preferences?.prefCloseWithLastStop) ? 1 : 0,
        closeWithAllStops: route?.closeWithAllStops || (isNewRoutesTracker && preferences?.prefCloseWithAllStops) ? 1 : 0,
        //convert mins to hours
        closeMinsAfterActivated: route?.closeMinsAfterActivated > 0 ? route?.closeMinsAfterActivated / 60 : 0,
        drivingDirectionsMins: route?.etaRouteDurationValue // duration time in minutes
      }))
      designForm?.setValues({
        driverSelect: driverId && drivers ? drivers.find(
          (driver) =>
            driver?.driverId.toString() ===
            driverId.toString()
        )
          : {}
      });

      //mark form to editable on true
      if (isTemplate) {
        dispatch(onUpdateRoute({ route, changesToSave: true }))
      } else {
        //it's a new routes tracker, flag for save points is active  
        dispatch(onUpdateRoute({
          route,
          ...(isNewRoutesTracker ? { changesToSavePoints: true } : {})
        }));
      }

      //make the zoom on the route.
      !formData?.id && centerRouteOnMap(route?.points);
    }

    if (route && !route?.id && !formData?.startingLoad) {
      setFormData(formData => ({
        ...formData,
        ...route,
        optimized: false,
        id: isNewRoutesTracker ? 0 : route?.id,
        startingLoad: true
      }))
    }

    //if no have route template
    if (!route && (paramDriverId || paramScheduledAt)) {
      driverId = paramDriverId;
      scheduledAt = paramScheduledAt;

      // date in UTC format
      fechaUTC = formatDatetime(scheduledAt, `YYYY/MM/DD h:mm A`, timeZoneUser)

      setFormData(formData => ({
        ...formData,
        scheduledAt: fechaUTC,
        driverId: driverId,
        optimized: false
      }))

      designForm?.setValues({
        driverSelect: driverId && drivers ? drivers.find(
          (driver) =>
            driver?.driverId.toString() ===
            driverId.toString()
        )
          : {}
      });
    }
  }, [loadingRoute, route])

  const centerRouteOnMap = (routePoints) => {
    if (!mapRef)
      return;
    const coordinatesCenter = []
    routePoints?.forEach(element => {
      coordinatesCenter.push({
        lat: element.latitude, lng: element.longitude
      })
    });
    mapRef?.current?.centerByFitBounds(coordinatesCenter)
  }

  useEffect(() => {
    setFormData(formData => ({ ...formData, points: route?.points }))
    centerRouteOnMap(route?.points)
  }, [route?.points])

  useEffect(() => {
    if (saveRoute > 0) {
      saveRouteChages()
    }
  }, [saveRoute]);

  const refreshDirections = useCallback((formData) => {
    dispatch(drawGetDirections(false));
    dispatch(addPointers([]));
    dispatch(setMapRoutesOptions({
      optimizeWaypoints: formData?.optimized || false,
      avoidTolls: formData?.avoidToll || false,
      avoidHighways: false,
      callbackWayPoints: formData?.optimized && !isEditPoint ? callbackWayPoints : null,
      routeModule: true,
      colorRoute: colorToRoute,
      showDirectionsPanel: isOpenModalRouteDirections,
      preserveViewport: isEditPoint,
      drawLineRoute: paramIsTemplate ? null : formData?.drawLineRoute,
      callbackDistancePoints: callbackDistancePoints
    }));

    // TODO: The drawGetDirections is taking time for to change the value in the redux
    if (window.clearRoutes) {
      clearTimeout(window.clearRoutes)
    }


    window.clearRoutes = setTimeout(() => {
      let newPointers = []
      //create the points on map when route comes to data
      formData?.points?.map((item) => {
        newPointers.push({
          ...item,
          //value : item?.sequence,
          layerName: TypeLayer?.FSMRoute,
          eventName: item?.typePoint
        })
      });


      dispatch(addPointers(newPointers));
      dispatch(drawGetDirections(true));
      window.clearRoutes = null;
    }, 500);
  });

  useEffect(() => {
    dispatch(setMapRoutesOptions({
      //optimizeWaypoints: formData?.optimized || false,
      avoidTolls: formData?.avoidToll || false,
      avoidHighways: false,
      //callbackWayPoints: !isEditPoint ? callbackWayPoints : null,
      routeModule: true,
      colorRoute: colorToRoute,
      noDrawMap: true,
      showDirectionsPanel: isOpenModalRouteDirections,
      preserveViewport: isEditPoint,
      drawLineRoute: paramIsTemplate ? null : formData?.drawLineRoute,
      callbackDistancePoints: callbackDistancePoints
    }));
  }, [isOpenModalRouteDirections])

  /*********************************************************
 * Print the map in options
*********************************************************/
  const onPrint = () => {
    dispatch(setToggleFullScreen(true));
    const panelContainer = document.getElementById('directionsPanel');
    const panelToPrint = document.getElementById('directionsPanelToPrint');
    if (panelContainer && panelToPrint) {
      panelToPrint.innerHTML = panelContainer.innerHTML;
    }
    dispatch(openModalCreateEditRoutePoint({ open: false }));

    setTimeout(() => {
      var elements = document.querySelectorAll("#id_sidePanel");
      elements.forEach(function (element) {
        element.classList.add('display-none-elementToPrint');
      });
      document.getElementById("idPanelRouteModal").classList.add('display-none-elementToPrint');

      document.getElementById("id_appContainer").classList.add('print-app-container');
      document.querySelector('body').classList.add('print-app-container');
      document.querySelector('html').classList.add('print-app-container');
      document.getElementById("divReferenceRoutes").classList.add('div-print-to-relative');
      document.getElementById("mapToPrint").classList.remove('route-class-element-map-complete-sidebar');
      document.getElementById('root').classList.add('print-app-container');
      document.querySelector('#root').classList.add('print-app-container');

      var containerManageElement = document.getElementById("containerManage");
      if (containerManageElement) {
        containerManageElement.classList.add('display-none-elementToPrint');
      }

      var containerElement = document.getElementById("containeGridNewRoutes");
      if (containerElement) {
        containerElement.classList.add('display-none-elementToPrint');
      }

      const classTabs = document.querySelector('.TabsIdsSettings');
      if (classTabs) {
        classTabs.classList.add('display-none-elementToPrint');
      }
      const modalTitle = document.querySelector('[aria-labelledby="modal-title"]');
      if (modalTitle) {
        modalTitle.classList.add('div-to-print');
      }
      mapRef.current?.setZoomOut(1);
    }, 1000);

    setTimeout(() => {
      dispatch(printView(true));
      setGeneratePrint(true);
    }, 2000);

  }

  useEffect(() => {
    if (generatePrint) {
      //.css-8ndowl
      window.print();
      setTimeout(() => {
        setGeneratePrint(false);
        dispatch(printView(false));
        dispatch(setToggleFullScreen(false));
        mapRef.current?.setZoomOut(-1);
        var elements = document.querySelectorAll("#id_sidePanel");
        elements.forEach(function (element) {
          element.classList.remove('display-none-elementToPrint');
        });
        document.getElementById("idPanelRouteModal").classList.remove('display-none-elementToPrint');

        document.getElementById("id_appContainer").classList.remove('print-app-container');
        document.querySelector('body').classList.remove('print-app-container');
        document.querySelector('html').classList.remove('print-app-container');
        document.getElementById("divReferenceRoutes").classList.remove('div-print-to-relative');
        document.getElementById("mapToPrint").classList.add('route-class-element-map-complete-sidebar');
        document.getElementById('root').classList.remove('print-app-container');
        document.querySelector('#root').classList.remove('print-app-container');

        var containerManageElement = document.getElementById("containerManage");
        if (containerManageElement) {
          containerManageElement.classList.remove('display-none-elementToPrint');
        }

        var containerElement = document.getElementById("containeGridNewRoutes");
        if (containerElement) {
          containerElement.classList.remove('display-none-elementToPrint');
        }

        const classTabs = document.querySelector('.TabsIdsSettings');
        if (classTabs) {
          //classTabs.classList.remove('hide-elementToPrint');
          classTabs.classList.remove('display-none-elementToPrint');
        }
        const modalTitle = document.querySelector('[aria-labelledby="modal-title"]');
        if (modalTitle) {
          modalTitle.classList.remove('div-to-print');
        }
        const panelToPrint = document.getElementById('directionsPanelToPrint');
        if (panelToPrint) {
          panelToPrint.innerHTML = '';
        }


      }, 1000);
    }
  }, [generatePrint])

  const callbackDistancePoints = (data) => {
    setDataPointsFromMap(prevData => ({
      ...prevData,
      distanceMeters: data?.distanceMeters || 0,
      etaRouteDurationValue: data?.etaRouteDurationValue || 0, //duration value in seconds
      points: data?.points || []
    }));
  }

  const callbackWayPoints = (waypointOrder) => {
    //get all points on route
    const newOrderOnRoute = [...formData?.points];
    //remove start route point
    const start = newOrderOnRoute.shift();

    //remove end route point
    const end = newOrderOnRoute.pop();

    let orderedWaypoints = [];

    // Agrega los puntos de ruta en el orden especificado por waypoint_order
    for (let i = 0; i < waypointOrder.length; i++) {
      const index = waypointOrder[i];
      orderedWaypoints.push(newOrderOnRoute[index]);
    }

    //add start
    orderedWaypoints.unshift(start);
    //add end again
    orderedWaypoints.push(end);

    orderedWaypoints = orderedWaypoints.filter(function (elemento) {
      return elemento !== undefined;
    });

    if (!compareSort(orderedWaypoints, formData?.points)) {
      const sequencesToUpdate = []
      sequencesToUpdate.push(...orderedWaypoints.map((newPoint, index) => {
        return {
          routePointId: newPoint.id,
          sequence: index
        };
      }));

      //only update when user save the route changes
      /* dispatch(routesUpdateStopOrder({
        routeId: formData?.id,
        sequence: sequencesToUpdate
      })); */

      let newPointers = [];
      let counterPoints = -1; // Initialize the counter outside the map   
      //create the points on map when route comes to data
      orderedWaypoints?.map((item, index) => {
        // Second part: Update counterPoints and assign values
        counterPoints = item?.typePoint === 'Stop' ? counterPoints + 1 : counterPoints; // Increment counter only if the type is 'Stop'
        newPointers.push({
          ...item,
          sequence : index,
          layerName: TypeLayer?.FSMRoute,
          eventName: item?.typePoint,
          counterStop: counterPoints,
          value: counterPoints
        })
      });

      //search route values.
      setFormData(formData => ({ ...formData, points: newPointers }))
      dispatch(onUpdateRoute({ route: { ...route, points: newPointers }, changesToSave: true }))
    }

  }

  function compareSort(array1, array2) {
    // have the same logitude
    if (array1.length !== array2.length) {
      return false;
    }

    // compare id attibutes
    for (let i = 0; i < array1.length; i++) {
      if (array1[i].id !== array2[i].id) {
        //eval lat and lng
        if (array1[i].latitude.toFixed(2) != array2[i].latitude.toFixed(2) || array1[i].longitude.toFixed(2) != array2[i].longitude.toFixed(2)) {
          return false;
        }
      }
    }

    // is the same order
    return true;
  }

  /**--------------------------------------------------------------------------------
   * Generates a numeric list from a given minimum value up to 168.
   * If the minimum value is a decimal, it rounds up to the next whole number.
   * 
   * @param {number} min - The starting number (can be a decimal).
   * @returns {Array} An array of objects with `value` and `text` properties.
   --------------------------------------------------------------------------------*/
  function generateNumberList(min) {
    //maxDaysToCloseRoute - 7 days - 168 hours
    const start = Math.ceil(min); // Round up to the nearest integer
    return Array.from({ length: maxDaysToCloseRoute - start + 1 }, (_, i) => ({
      value: start + i,
      text: `${start + i}`
    }));
  }

  /* --------------------------------------------------------------------------------
   * Converts seconds to hours, rounding up to the next whole number.
   * 
   * @param {number} seconds - The number of seconds to convert.
   * @returns {number} The total hours, rounded up.
   --------------------------------------------------------------------------------*/
  function convertSecondsToHours(seconds = 1) {
    return Math.ceil(seconds / 3600); // 1 hour = 3600 seconds
  }

  //list data off closeMinAfterActivated
  let listCloseMinsAfterActivated = generateNumberList(convertSecondsToHours(dataPointsFromMap?.etaRouteDurationValue || 1));
  onDisableSave && onDisableSave(!formData?.title || formData?.title && formData?.title.trim().length < 3);

  return (
    <Form
      ref={designForm.ref}
      loading={loadingRoute}
      onValidSubmit={() => { }}
      onChangeValues={(values) => {
      }}
    >
      <div style={{ width: '100%' }}>
        <div>
          <label className="input-normal-label">{messages['routes_name']}</label>
        </div>
        <Grid
          container
          wrap="nowrap"
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ gridGap: 10 }}
        >
          <Grid item>
            <div>
              <IconPicker
                color={colorToRoute ? colorToRoute.replace('#', '') : formData?.color || defaultColor}
                icon={null}
                options={["color"]}
                onChange={(color, icon) => {
                  setFormData(prevFormData => {
                    const updatedFormData = { ...prevFormData, color: color, selectedColor: true };

                    // Auto-update the route color on the map
                    const newColor = color?.replace('#', '');
                    const newColorRoute = newColor ? `#${newColor}` : `#${defaultColor}`;

                    dispatch(drawGetDirections(false));
                    dispatch(addPointers([]));
                    dispatch(setMapRoutesOptions({
                      optimizeWaypoints: updatedFormData?.optimized || false,
                      avoidTolls: updatedFormData?.avoidToll || false,
                      avoidHighways: false,
                      routeModule: true,
                      colorRoute: newColorRoute,
                      showDirectionsPanel: isOpenModalRouteDirections,
                      preserveViewport: true,
                      drawLineRoute: paramIsTemplate ? null : updatedFormData?.drawLineRoute,
                      callbackDistancePoints: callbackDistancePoints
                    }));

                    if (window.clearRoutes) {
                      clearTimeout(window.clearRoutes);
                    }

                    window.clearRoutes = setTimeout(() => {
                      const newPointers = [];
                      updatedFormData?.points?.forEach((item) => {
                        newPointers.push({
                          ...item,
                          layerName: TypeLayer?.FSMRoute,
                          eventName: item?.typePoint
                        });
                      });
                      dispatch(addPointers(newPointers));
                      dispatch(drawGetDirections(true));
                      window.clearRoutes = null;
                    }, 500);

                    return updatedFormData;
                  });
                  dispatch(onUpdateRoute({ route: { ...route, color: color }, changesToSave: true }))
                }}
              />
            </div>
          </Grid>
          <Grid item xs>
            <Input
              loading={loadingRoute}
              id="name"
              type={"text"}
              placeholder={messages['routes_name']}
              value={formData?.title || ""}
              onChange={(value) => {
                setFormData(formData => ({ ...formData, title: value }))
              }}
              required
              requiredMessage={messages['required_field']}
              minLengthMessage={messages['route_minLengthMessage']}
              maxLengthMessage={messages['route_maxLengthMessage']}
              minLength={4}
              maxLength={50}
            />
            {
              (formData?.title?.length > 0 && formData?.title?.length < 3) &&
              <small className="text-danger" style={{ paddingBottom: 10, display: 'block' }}>
                {`${messages['fsmRoute_edit_panel_route_accordion_name_mandatory']}`}
              </small>
            }
          </Grid>
        </Grid>
        <Grid
          container
          wrap="nowrap"
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ gridGap: 10 }}
          style={{ paddingTop: 15 }}
        >
          {
            !paramIsTemplate
            &&
            <Grid item style={{ width: '100%' }}>
              <Select
                style={{ width: '100%' }}
                name="driverSelect"
                textField="name"
                label={messages['fsmRoute_edit_panel_route_driver']}
                valueField="driverId"
                placeholder={messages['fsmRoute_edit_panel_route_driver']}
                isMulti={false}
                options={drivers || []}
                isDisabled={false || loadingRoute || loadingCloneRoute || loadingDrivers}
                isLoading={loadingRoute || loadingCloneRoute || loadingDrivers}
                showPillsOutside={true}
                isClearable={true}
                isSearchable={true}
                value={
                  drivers
                    ? drivers.find(
                      (driver) =>
                        driver?.driverId.toString() ===
                        formData.driverId?.toString()
                    )
                    : {}
                }
                onChange={(value) => {
                  setFormData(formData => ({ ...formData, driverId: value?.driverId || 0 }))
                }} />
            </Grid>
          }
          {
            !paramIsTemplate
            &&
            <Grid item style={{ width: '100%' }}>
              <div>
                <label className='label-gtc-rc'>{messages['fsmRoute_edit_panel_route_schedule_at']}</label>
              </div>
              <div style={{ marginTop: 5 }}>
                <DatePicker
                  showButtons={true}
                  showTimePicker={true}
                  //calendarPosition={"bottom"}
                  placeholder={messages['module_routes_select_date']}
                  format={`${GetFormatForMoment(dateformat)}`}
                  value={formData?.scheduledAt}
                  minDate={new Date()}
                  onChange={(newDate) => setFormData(formData => ({ ...formData, scheduledAt: newDate }))} />
              </div>
            </Grid>
          }
          {
            HasPermission(user, ['dapprta'], [250])
            &&
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              style={{ paddingBottom: 5 }}
            >
              <Grid item xs={1}>
                <IconButton
                  variant={"secondary"}
                  isDisabled={false}
                  icon="directions"
                  style={formData?.points?.length >= 23 ? { fontSize: 22, color: '#F0F0F0' } : { fontSize: 22, color: '#212121' }}
                  tooltip={messages['fsmRoute_label_route_directions']}
                  onClick={(e) => {
                    if (e) e.preventDefault();
                    if (!isOpenModalRouteDirections) {

                      mapRef.current.showNormalMarkers()
                      dispatch(openModalMarkerRoute({ open: false, data: null }))
                      dispatch(openModalRouteDirections({ open: true, isRealtimeMaps: isRealtimeMaps || false }))

                      refreshDirections(formData);
                    }
                  }}
                  disabled={formData?.points?.length >= 23}
                />
              </Grid>
              <Grid item xs={1}>
                <IconButton
                  variant={"secondary"}
                  isDisabled={false}
                  icon="print"
                  tooltip={messages['print']}
                  onClick={(e) => {
                    if (e) e.preventDefault();
                    dispatch(openModalRouteDirections({ open: false, isRealtimeMaps: isRealtimeMaps || false }));
                    dispatch(openModalMarkerRoute({ open: false, data: null }))
                    refreshDirections(formData);
                    setTimeout(() => {
                      onPrint();
                    }, 1000);
                  }}
                />
              </Grid>
              {
                formData?.points?.length > 0
                &&
                <Grid item xs={1}>
                  <IconButton
                    variant={"secondary"}
                    isDisabled={false}
                    icon="delete_sweep"
                    tooltip={messages['fsmRoute_label_delete_all_stop']}
                    onClick={(e) => {
                      if (e) e.preventDefault();
                      dispatch((openModalDeleteRoutePoints({ open: true, routeId: formData.id })));
                    }}
                  />
                </Grid>
              }
            </Grid>
          }
        </Grid>
        {
          errorOnMap
          &&
          <div className='div-message-route'>
            {
              <small className="route-info-message-edit-form" style={{ paddingTop: 5 }}>
                {messages['fsmRoute_edit_panel_route_remove_point']}
              </small>
            }
          </div>
        }

        {
          (loadingDeleteModal || loadingRoute || loadingCloneRoute)
            ?
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Loading />
            </div>
            :
            <></>
        }

        <div /* className='routeTooltip' */ style={{ paddingTop: 10 }}>
          <div style={{ paddingBottom: '25px' }}>


            <AccordionComponent
              title={messages['fsmRoute_edit_panel_route_accordion_point']}
              expanded={accordionValue ? accordionValue[0]?.status : false}
              onChange={(item) => {
                let accordionVar = [...accordionValue]
                accordionVar[0].status = item
                setAccordionValue(accordionVar)
              }}
            >
              <CreateEditRoutePoint
                mapRef={mapRef}
                points={newPointers}
                route={route}
                parentSetFormData={setFormData}
                setPointUnsaved={setPointUnsaved}
              />
            </AccordionComponent>

            <AccordionComponent
              title={messages['fsmRoute_edit_panel_route_accordion_stops']}
              expanded={accordionValue ? accordionValue[1]?.status : false}
              onChange={(item) => {
                let accordionVar = [...accordionValue]
                accordionVar[1].status = item
                setAccordionValue(accordionVar)
              }}
            >

              <div className={paramIsTemplate ? "route-container-outside" : "route-container-outside-isAssigned"}>
                <div className="route-container-inside">
                  <DragDropList
                    items={route?.points || []} //este es el que carga la data por ahora
                    keyName="id"
                    className="route-stops-list-container"
                    isDragDisabled={isEditPoint ? true : false}
                    itemRenderer={(item) => {
                      return (
                        <div style={{ padding: '0px 0px 6px 0px' }}>
                          <div className="route-point-card">
                            <Grid
                              container
                              direction="row"
                              justifyContent="flex-start"
                              alignItems="center"
                              style={{ height: 30 }}
                              onClick={() => {
                                //setSizeMarkerIcon
                                mapRef.current.showNormalMarkers()
                                mapRef.current.setSizeMarkerIcon(item?.id, TypeLayer.FSMRoute, EnumIconSize.Magnified)
                                dispatch(openModalMarkerRoute({ open: true, data: item }))
                              }}
                            >

                              <Grid item style={{ position: 'relative' }}/*  className='route-marker-inHover' */>
                                {
                                  (item.sequence == 0)
                                    ?
                                    <div
                                      className='route-point'
                                      style={{ backgroundColor: colorToRoute }}
                                    >{messages["routes_start"]}</div>
                                    :
                                    (item.sequence == route?.points?.length - 1 || route?.points?.length <= 2)
                                      ?
                                      <div
                                        className='route-point'
                                        style={{ backgroundColor: colorToRoute }}
                                      >{messages["routes_end"]}</div>
                                      :
                                      <div className='point-stop'>{messages["routes_stop"]}</div>
                                }
                              </Grid>
                              <Grid item className='route-showInHover route-icon-dot-move-inHover'>
                                <DragIndicatorIcon className="route-icon-move" />
                              </Grid>
                              {
                                (item?.landmarkId > 0)
                                &&
                                <Grid item>
                                  <Typography
                                    noWrap
                                    variant="subtitle2"
                                    style={{ color: '#b5b5b5', paddingRight: 10 }}
                                  >
                                    {findLandmarkName(item?.landmarkId)}
                                  </Typography>
                                </Grid>
                              }
                              <Grid item xs zeroMinWidth>
                                <Typography
                                  noWrap
                                  variant="subtitle2"
                                  style={{ color: '#515151' }}
                                >
                                  {item?.name || item?.address}
                                </Typography>
                              </Grid>
                              {
                                ((!isEditPoint) && ((item.sequence == 0) || (item.sequence == route?.points?.length - 1 || route?.points?.length <= 2)))
                                &&
                                <Grid item>
                                  <div style={{ paddingRight: 10, cursor: 'pointer' }} key={item?.sequence} className="route-marker"  /* className="route-marker route-marker-inHover" */>
                                    <Tooltip
                                      placement="bottom"
                                      title={
                                        (item.sequence == 0) ?
                                          item?.typePoint == 'Stop' ? messages['fsmRoute_edit_panel_route_info_points_stop_start'] : messages['fsmRoute_edit_panel_route_info_points_waypoint_start']
                                          :
                                          item?.typePoint == 'Stop' ? messages['fsmRoute_edit_panel_route_info_points_stop_end'] : messages['fsmRoute_edit_panel_route_info_points_waypoint_end']
                                      }
                                    >
                                      <ModeOfTravelIcon
                                        style={{
                                          color: item?.typePoint == 'Stop' ? '#f50057' : '#686968'
                                        }}
                                        onClick={() => {
                                          let counterPoints = -1; // Initialize the counter outside the map

                                          let routePoints = route?.points.map((point, index) => {
                                            // First part: Modify typePoint and eventName
                                            const isTargetPoint = point.id === item?.id; // Check if the current point is the one to modify
                                            const newTypePoint = isTargetPoint
                                              ? (item.typePoint === 'Waypoint' ? 'Stop' : 'Waypoint') // Toggle between 'Waypoint' and 'Stop'
                                              : point.typePoint; // Keep the original type if it's not the target point

                                            // Second part: Update counterPoints and assign values
                                            counterPoints = newTypePoint === 'Stop' ? counterPoints + 1 : counterPoints; // Increment counter only if the type is 'Stop'

                                            // Return the updated point object
                                            return {
                                              ...point, // Keep all original properties of the point
                                              typePoint: newTypePoint, // Updated typePoint
                                              eventName: isTargetPoint ? newTypePoint : point.eventName, // Update eventName if it's the target point
                                              sequence: index, // Assign the sequence based on the index
                                              counterStop: counterPoints, // Assign the current counter value
                                              value: counterPoints, // Assign the same counter value as 'value'
                                              oldTypePoint: item?.typePoint // Assign the original typePoint from the item
                                            };
                                          });

                                          //update the data of the points before the save
                                          dispatch(onUpdateRoute({ route: { ...route, points: routePoints }, changesToSave: true }));
                                        }} />
                                    </Tooltip>
                                  </div>
                                </Grid>
                              }
                              <Grid item>
                                <IconButton
                                  variant={"secondary"}
                                  isDisabled={!item?.note} // dissabled controls if the note is empty
                                  icon="comment"
                                  style={{
                                    fontSize: 12,
                                    color: '#212121',
                                    visibility: item?.note ? 'visible' : 'hidden' // Control visible depends on the note
                                  }}
                                  className="route-stop-action"
                                  tooltip={item?.note}
                                  size={'xsmall'}
                                  onClick={(e) => {
                                    if (e) e.preventDefault();
                                  }}
                                />
                              </Grid>
                              <Grid item style={{ position: 'relative' }}>
                                <MenuComponent
                                  isDisable={false || isEditPoint}
                                  icon={'more_vert'}
                                  className="route-actions route-icon-menu route-showInHover"
                                  options={[
                                    messages['routes_edit'],
                                    messages['routes_delete']
                                  ]}
                                  key='1'
                                  onClick={(type) => {
                                    switch (type) {
                                      case messages['routes_edit']:
                                        dispatch(openModalCreateEditRoutePoint({ typePoint: item?.typePoint || 'Stop', point: item }));
                                        let accordionVar = [...accordionValue]

                                        if (!accordionVar[0].status) {
                                          accordionVar[0].status = true
                                          setAccordionValue(accordionVar)
                                        }
                                        break

                                      case messages['routes_delete']:
                                        //Delete Route Point

                                        const pointToDelete = [];
                                        let sequence = 0
                                        route?.points?.forEach((point, index) => {
                                          if (!(point.id == item.id && point.name == item.name)) {
                                            pointToDelete.push({
                                              ...point,
                                              sequence: sequence
                                            })
                                            sequence += 1;
                                          }
                                        })
                                        setFormData(formData => ({ ...formData, points: pointToDelete, drawLineRoute: null }))
                                        dispatch(onUpdateRoute({ route: { ...route, points: pointToDelete }, changesToSave: true, drawLineRoute: null }))

                                        break;
                                    }
                                  }}
                                />
                              </Grid>
                              <Grid item /* className='route-marker-inHover' */>
                                <div key={item?.sequence} className="route-marker"  /* className="route-marker route-marker-inHover" */>
                                  <IconReactMarkerRouteFSMPoint color={item?.typePoint == 'Stop' ? '#f50057' : '#ff6623'} number={item?.typePoint == 'Stop' ? item?.counterStop + 1 : 0} />
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      );
                    }}
                    onDragEnd={(result) => {
                      if (isEditPoint) return;
                      if (!result.destination) return;
                      const { points } = formData;
                      if (points.length <= 1) return;

                      let newPoints = [...formData?.points]

                      const [reorderedItem] = newPoints.splice(result.source.index, 1);
                      newPoints.splice(result.destination.index, 0, reorderedItem);

                      //add start point

                      //update sequence to points array
                      let counterPoints = -1; //to start first element in 0
                      newPoints = newPoints.map((newPoint, index) => {
                        counterPoints = newPoint?.typePoint == 'Stop' ? counterPoints + 1 : counterPoints;
                        return {
                          ...newPoint,
                          sequence: index,
                          counterStop: counterPoints,
                          value: counterPoints
                        };
                      });

                      setFormData(formData => ({ ...formData, points: newPoints, optimized: false, drawLineRoute: null }))
                      dispatch(onUpdateRoute({ route: { ...route, points: newPoints, optimized: false }, changesToSave: true }))
                      refreshDirections({ ...formData, points: newPoints, optimized: false })
                    }}
                  >
                  </DragDropList>
                </div>
              </div>



            </AccordionComponent>
            <Preferences
              preferencesKey={preferencesKey}
              onInitialPreferences={(data) => {
                setPreferences(data);
                if (data && !preferences) {
                  if (isNewRoutesTracker) {
                    setFormData(formData => ({
                      ...formData,
                      closeWithLastStop: data?.prefCloseWithLastStop || false,
                      closeWithAllStops: data?.prefCloseWithAllStops || false,
                      checkCloseMinsAfterActivated: data?.prefCloseMinsAfterActivated || false,
                      closeMinsAfterActivated: data?.prefCloseMinsAfterActivated == true ? listCloseMinsAfterActivated[0]?.value : formData?.closeMinsAfterActivated
                    }))
                  }
                }
              }}
            >

              <div style={{ paddingTop: 20 }} /*  style={{ minHeight: formData?.showDirectionsMap ? 550 : 200 }} */>
                <div style={{ display: 'flex' }}>
                  <div>
                    <label className={'labelMapSettings'} style={{ fontWeight: 600, paddingRight: 10 }}>
                      {messages['routes_avoidTolls']}
                    </label>
                    <Switch
                      backgroundColorClass='gtc-rc-blue-switch'
                      checked={formData?.avoidToll || false}
                      optionLabels={[messages['yes'], messages['no']]}
                      size="large"
                      labelPosition="left"
                      onChange={(value) => {
                        setFormData(formData => ({ ...formData, avoidToll: value }));
                        const routeProperties = { ...preferences, optimized: false, avoidToll: value };
                        setTimeout(() => {
                          dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: routeProperties }));
                        }, 500);
                      }}
                    />
                  </div>
                  <div style={{ padding: '10px 0px 0px 50px' }}>
                    <Button
                      onClick={(e) => {
                        if (e) e.preventDefault();
                        //remove the marker
                        refreshDirections({ ...formData, optimized: true });

                        //is change values on points route
                        dispatch(onUpdateRoute({ changesToSave: true, drawLineRoute: null }))
                        setFormData(formData => ({ ...formData, drawLineRoute: null }))
                      }}
                      style={{ whiteSpace: 'nowrap' }}
                      variant="green"
                    >
                      {messages['routes_optimizeRoute']}
                    </Button>
                  </div>
                  <div style={{ padding: '15px 0px 0px 5px' }}>
                    <Tooltip
                      placement="bottom"
                      title={messages['fsmRoute_edit_panel_route_info_optimize_route']}
                    >
                      <Icons name="help" size="medium" />
                    </Tooltip>
                  </div>
                </div>
              </div>

              {
                !paramIsTemplate
                &&
                <div>
                  <div style={{ paddingTop: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <label className={'labelMapSettings'} style={{ fontWeight: 600 }}>
                        {messages['routes_useDriverApp']}
                      </label>
                      <div style={{ paddingLeft: 5 }}>
                        <Tooltip
                          placement="bottom"
                          title={messages['routes_useDriverAppInfo']}
                        >
                          <Icons

                            name="help"
                            //name="info"
                            size="medium"
                          />
                        </Tooltip>
                      </div>
                    </div>
                    <Switch
                      //backgroundColorClass='gtc-rc-blue-switch' 
                      checked={formData?.useDriverApp == 1 ? true : false}
                      optionLabels={[messages['yes'], messages['no']]}
                      size="large"
                      labelPosition="right"
                      onChange={(value) => {
                        setFormData(formData => ({ ...formData, useDriverApp: value ? true : false }));
                      }} />
                  </div>
                  {/* Options for routes */}
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px", paddingTop: 30 }}>
                    <div>
                      <label className='route-info-close-route-title '>{messages['fsmRoute_edit_panel_route_close_option_title']}</label>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Switch
                        checked={formData?.closeWithLastStop == 1 ? true : false}
                        optionLabels={['', '']}
                        size="small"
                        labelPosition="right"
                        onChange={(value) => {
                          setFormData(formData => ({ ...formData, closeWithLastStop: value ? true : false }));
                          //set this values in preference
                          const routeProperties = { ...preferences, prefCloseWithLastStop: value ? true : false };
                          dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: routeProperties }));
                        }} />
                      <div>
                        <label style={{ paddingTop: 5 }} >
                          {messages['fsmRoute_edit_panel_route_close_option_final_stop']}
                        </label>
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Switch
                        //backgroundColorClass='gtc-rc-blue-switch' 
                        checked={formData?.closeWithAllStops == 1 ? true : false}
                        optionLabels={['', '']}
                        size="small"
                        labelPosition="right"
                        onChange={(value) => {
                          setFormData(formData => ({ ...formData, closeWithAllStops: value ? true : false }));
                          //set this values in preference
                          const routeProperties = { ...preferences, prefCloseWithAllStops: value ? true : false };
                          dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: routeProperties }));
                        }} />
                      <div>
                        <label style={{ paddingTop: 5 }} >
                          {messages['fsmRoute_edit_panel_route_close_option_final_all_stop_visited']}
                        </label>
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Switch
                        checked={formData?.checkCloseMinsAfterActivated == 1 ? true : false}
                        optionLabels={['', '']}
                        size="small"
                        labelPosition="right"
                        onChange={(value) => {
                          setFormData(formData =>
                          ({
                            ...formData,
                            checkCloseMinsAfterActivated: value ? true : false,
                            closeMinsAfterActivated: value == true && formData?.closeMinsAfterActivated == 0 ? listCloseMinsAfterActivated[0]?.value : formData?.closeMinsAfterActivated
                          }));
                          //set this values in preference
                          const routeProperties = { ...preferences, prefCloseMinsAfterActivated: value ? true : false };
                          dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: preferencesKey, preferenceValue: routeProperties }));

                        }} />
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <label style={{ paddingTop: 5 }} >
                          {messages['fsmRoute_edit_panel_route_close_option_final_after']}
                        </label>
                        <div className='route-info-close-route-select'>
                          <Select
                            id="input-radius"
                            value={formData?.closeMinsAfterActivated > 0
                              ?
                              listCloseMinsAfterActivated?.find((x) => x.value == formData?.closeMinsAfterActivated) || listCloseMinsAfterActivated[0]
                              :
                              listCloseMinsAfterActivated[0]
                            }
                            onChange={(value) => {
                              setFormData(formData => ({ ...formData, closeMinsAfterActivated: value?.value }));
                            }}
                            options={listCloseMinsAfterActivated}
                            textField="text"
                            valueField="value"
                            placeholder=""
                          />
                        </div>
                        <label style={{ paddingTop: 5 }} >
                          {messages['fsmRoute_edit_panel_route_close_option_final_after_end']}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </Preferences>
          </div>
        </div>
      </div>
    </Form>
  )

})

export default EditPanelForm;